import React from 'react';
import BackButton from '../components/BackButton';
import DragonBricks from '../components/DragonBricks';

function DragonBricksPage() {
  return (
    <>
      <BackButton />
      <DragonBricks />
    </>
  );
}

export default DragonBricksPage;
